import { render, staticRenderFns } from "./FiltersModal.vue?vue&type=template&id=c4360550&scoped=true&lang=pug"
import script from "./FiltersModal.vue?vue&type=script&lang=js"
export * from "./FiltersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4360550",
  null
  
)

export default component.exports